import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet-async";
import "./LandingPage.css";
import { CONFIG } from "../../constants/config";

const LandingPage = () => {
  const [ref] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  const handleScrollClick = () => {
    const nextSection = document.querySelector(".project-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>I-PROJECTS | 인하대학교 서비스를 더 편리하게</title>
        <meta name="description" content={CONFIG.META.DESCRIPTION} />
        <meta name="keywords" content={CONFIG.META.KEYWORDS} />
        <meta property="og:image" content={CONFIG.DOMAIN.IMAGE_URL} />
        <link rel="canonical" href={CONFIG.DOMAIN.URL} />
      </Helmet>
      <section className="landing-page" ref={ref}>
        <motion.div
          className="landing-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.h1
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 100 }}
            className="glowing-text"
          >
            I-PROJECTS
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="subtitle"
          >
            인하대학교 서비스를 더 편리하게
          </motion.p>

          <motion.div
            className="scroll-indicator"
            onClick={handleScrollClick}
            initial={{
              opacity: 0,
              x: "-50%",
            }}
            animate={{
              opacity: 1,
              x: "-50%",
            }}
            transition={{ delay: 1 }}
            whileHover={{ scale: 1.1, x: "-50%" }}
            whileTap={{ scale: 0.9, x: "-50%" }}
          >
            <span>Scroll Down</span>
            <div className="scroll-arrows">
              <div className="scroll-arrow"></div>
              <div className="scroll-arrow second"></div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    </>
  );
};

export default LandingPage;
